<p-autoComplete [(ngModel)]="selectedOffice" [suggestions]="dropdownItems" appendTo="body" optionLabel="name" placeholder="Select an Office"
  (completeMethod)="search($event)" [completeOnFocus]="true" (onSelect)="onOfficeSelected($event)" (onClear)="onOfficeCleared()" [disabled]="disabled" [dropdown]="true"
  [forceSelection]="true">
  <ng-template let-office pTemplate="item">
    {{office.name}}
  </ng-template>
</p-autoComplete>
